import { render, staticRenderFns } from "./copyBottun.vue?vue&type=template&id=24d4c9da&scoped=true&"
import script from "./copyBottun.vue?vue&type=script&lang=js&"
export * from "./copyBottun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4c9da",
  null
  
)

export default component.exports